import { render, staticRenderFns } from "./FormularioDadosGeraisOperacao.vue?vue&type=template&id=2805ff4a&scoped=true&lang=pug"
import script from "./FormularioDadosGeraisOperacao.vue?vue&type=script&lang=js"
export * from "./FormularioDadosGeraisOperacao.vue?vue&type=script&lang=js"
import style0 from "./FormularioDadosGeraisOperacao.vue?vue&type=style&index=0&id=2805ff4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2805ff4a",
  null
  
)

export default component.exports